import apiClient from './apiClient';
import type {
    TestCategory,
    CreateTestCategoryDto,
    UpdateTestCategoryDto,
} from '../types/types';

const testCategoriesService = {
    getAll: async (): Promise<TestCategory[]> => {
        const res = await apiClient.get<TestCategory[]>('/test-categories');
        return res.data;
    },

    getById: async (id: number): Promise<TestCategory> => {
        const res = await apiClient.get<TestCategory>(`/test-categories/${id}`);
        return res.data;
    },

    getByType: async (type: string): Promise<TestCategory> => {
        const res = await apiClient.get<TestCategory>(`/test-categories/by-type/${encodeURIComponent(type)}`);
        return res.data;
    },

    create: async (dto: CreateTestCategoryDto): Promise<TestCategory> => {
        const res = await apiClient.post<TestCategory>('/test-categories', dto);
        return res.data;
    },

    update: async (id: number, dto: UpdateTestCategoryDto): Promise<TestCategory> => {
        const res = await apiClient.patch<TestCategory>(`/test-categories/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/test-categories/${id}`);
        return res.data;
    },
};

export default testCategoriesService;
